import { render, staticRenderFns } from "./index-portfolio.vue?vue&type=template&id=5b5abdd7&"
import script from "./index-portfolio.vue?vue&type=script&lang=js&"
export * from "./index-portfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports